import { cpManagementRoute } from '@/modules/administration/charge-point-management/routes';
import { createRoute, redirect } from '@tanstack/react-router';

export const cpManagementIndexRoute = createRoute({
  getParentRoute: () => cpManagementRoute,
  path: '/',
  wrapInSuspense: true,
  beforeLoad: () => {
    throw redirect({
      to: '/admin/charge-point-management/status',
    });
  },
});
